import React, { Component } from 'react';
import {firebaseApp} from '../firebase';

class Etapa6 extends Component {

    state = {
        comoConheceu: '',
        selecionado: false
    }
    
    componentWillMount(){
        this.setState({
            medico: this.props.location.state.medico,
            avaliacaoRecepcao: this.props.location.state.avaliacaoRecepcao,
            avaliacaoMedico: this.props.location.state.avaliacaoMedico,
            avaliacaoEspacoFisico: this.props.location.state.avaliacaoEspacoFisico,
            avaliacaoEquipe: this.props.location.state.avaliacaoEquipe
        })
    }

    componentDidUpdate(){
        console.log(this.state);
    }

    handleChange(event){
        this.setState({comoConheceu: event.target.value});
        console.log(this.state)
    }

    render() {
        return (
            <div>
                <center>
                    <h1 style={{marginTop:'8%'}}>Como voce conheceu a clínica? </h1>
                </center>

                <div className="container">
                    <div className="row d-flex justify-content-center" style={{marginTop:'5%'}}>
                        
                            <select value={this.state.value} className="comboBoxIndicacao"
                                onChange={event => this.setState({comoConheceu: event.target.value, selecionado: true})}>
                                <option value="">Selecione uma opção</option>
                                <option value="indicacao-amigo">Indicação de Amigo</option>
                                <option value="indicacao-internet">Internet e Redes Sociais</option>
                                <option value="indicacao-medico">Indicação do Médico</option>
                            </select>
                    </div>
                    <br /><br/>
                    <center>
                        {this.state.selecionado && 
                            <button type="submit" className="btn btn-block btn-success btn-home" onClick={() => {
                                    firebaseApp.database().ref().push(this.state);
                                    this.props.history.push({pathname:`/7`})
                                }}>Próximo</button>
                        }
                    </center>

                </div>
            </div>
        );
    }
}

export default Etapa6;